import React from 'react';
import { compose, pure } from 'recompose';
import { NavLink } from 'react-router-dom';
import styled, { withTheme } from 'styled-components';
import { TickerPriceUnit } from './tickerUnit';
import routes from 'constants/routes';
import { device } from 'helpers/screenSizes';

const LastPrice = ({ lastTradePrice, product }) => {
  const selectedProductLoaded = lastTradePrice && product;

  if (!selectedProductLoaded) {
    return null;
  }

  const lastPrice = lastTradePrice || '-';

  return (
    <TickerPriceUnit
      label={`Last Price (${product.quoting_asset.symbol})`}
      price={lastPrice}
      hasPriceMovement
    />
  );
};

const OptionsUnitWrapper = styled.div`
  margin-right: 14px;
  cursor: pointer;
  font-size: 14px;
  font-family: var(--fontRegular);

  .active .options-label {
    @media ${device.up.lg} {
      background: ${props => props.selected && '#22303e'};
      border-top: ${props =>
        props.selected && `2px solid ${props.theme.primaryTheme}`};
    }

    @media ${device.down.lg} {
      color: ${props => props.theme.primaryTheme};
      border-bottom: ${props =>
        props.selected && `2px solid ${props.theme.primaryTheme}`};
    }
  }

  .options-label {
    padding: 0 16px;
    display: flex;
    align-items: center;
    height: 100%;

    @media ${device.down.lg} {
      padding: 7px 0px;
      margin: 0 10px;
      color: ${props => props.theme.secondaryText};
    }
  }
`;

const enhance = compose(withTheme, pure);

export const OptionsUnit = enhance(({ label, path }) => (
  <OptionsUnitWrapper selected>
    <NavLink to={path}>
      <div className="options-label">{label}</div>
    </NavLink>
  </OptionsUnitWrapper>
));

export const HeaderOptions = props => {
  return (
    (<React.Fragment data-palette="HeaderOptions">
      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-5 col-xxs-10 headerlastprice">
        <LastPrice {...props} />
      </div>
      <div className=" col-xxl-13 col-xl-11 col-lg-11 col-md-9 col-xxs-24 headeroptions initial-padding">
        <OptionsUnit label="Trade" path={routes.easy_options.trade} selected />
        <OptionsUnit label="Positions" path={routes.easy_options.position} />
        <OptionsUnit label="FAQs" path={routes.easy_options.faq} />
      </div>
    </React.Fragment>)
  );
};
